// extracted by mini-css-extract-plugin
export default {"FAQ":"FAQ_FAQ__VjqVv","dividing":"FAQ_dividing__t+wKr","first":"FAQ_first__z6vlD","second":"FAQ_second__F7WtK"};